'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// @ts-nocheck
exports.default = {
    chartThemePrimaryColor: '#BAA8BD',
    chartThemeSecondaryColor: '#3E4836',
    chartThemeSecondaryLineColor: '#3E4836',
    chartThemePrimayLineTension: 0.4,
    chartThemeSecondaryLineTension: 0.4
};